import http from '../http';

export default {
  logout: () => {
    return http.delete('api/v1/auth/sign-out');
  },
};
